<script>
    import api from '../../api';
    
    import {bootstrapDangerGrowl as errorGrowl} from "../../../../Util/growler";
    
    import LoadingBox from "../../../../Components/Util/LoadingBox.vue";
    
    export default {
        created() {
            const vm = this;
            
            api.getNewsroomItem(vm.id).then(
                newsroomItem => vm.newsroomItem = newsroomItem,
                err => {
                    errorGrowl(err);
                    vm.$router.push('/Newsroom');
                }
            );
        },
        render(createElement, context) {
            if(!this.newsroomItem){
                return createElement(LoadingBox);
            }
            
            return this.$scopedSlots.default({
                newsroomItem: this.newsroomItem
            });
        },
        data: () => ({
            newsroomItem: null
        }),
        props: {
            id: {
                type: String,
                required: true
            }
        }
    }
</script>